import * as helpers from './helpers';
import { system } from './system';
const isLocalDevelopment = system.nodeEnv === 'development';
// The bootstrapping <script>. Under the hosted Vite build the entry is an ES
// module (document.currentScript === null), so this is resolved by locating the
// loader-injected bundle script; under the immersive webpack build it is the
// classic currentScript. See helpers.getEntryScript.
const currentScript = helpers.getEntryScript();
const jsEntryPoint = (currentScript === null || currentScript === void 0 ? void 0 : currentScript.src) || '';
// Per-request CSP nonce propagated by the backend (BENG-4092): it is stamped on
// the loader <script>, and the loader copies data-* onto the injected bundle
// script, so it reaches us here as `data-csp-nonce`. We prefer the `.nonce` IDL
// property and fall back to the data attribute, because the `nonce` *content*
// attribute is scrubbed from getAttribute()/attributes by browsers for security.
export const cspNonce = (currentScript === null || currentScript === void 0 ? void 0 : currentScript.nonce) || (currentScript === null || currentScript === void 0 ? void 0 : currentScript.dataset.cspNonce) || '';
const getEnvironment = () => helpers.getEnvironment(system, location.hostname, jsEntryPoint);
const getIsland = () => helpers.getIsland(system, location.hostname, jsEntryPoint);
const getBaseHost = () => {
    const env = getEnvironment();
    const baseHost = {
        devbox: `${location.hostname}`,
        local: `cloudbeds-local.com`,
        prod: `cloudbeds.com`,
        stage: `cloudbeds-stage.com`,
    };
    return baseHost[env];
};
export const getAssetPath = () => {
    if (system.staticFiles) {
        return system.staticFiles;
    }
    return jsEntryPoint.indexOf('/static/js/') > -1
        ? jsEntryPoint.split('/static/js/')[0]
        : jsEntryPoint.substring(0, jsEntryPoint.lastIndexOf('/'));
};
export const getApiBaseUrl = () => {
    return system.apiBaseUrl || `https://api.${getBaseHost()}`;
};
export function getBaseUrl() {
    return system.mfdBaseUrl || `https://${getIsland()}.${getBaseHost()}`;
}
/**
 * Base for the public `booking-engine/v1` API. Distinct from the axios default
 * (`/booking`), which serves the legacy endpoints.
 */
export function getBookingEngineApiUrl() {
    return `${getBaseUrl()}/booking-engine/v1`;
}
export function getExternalPaymentBaseUrl() {
    return system.paymentBaseUrl || getBaseUrl();
}
export const getMarketingInsightServiceApi = () => {
    return (system.marketingInsightesServiceApiBase ||
        `${getApiBaseUrl()}/marketing-insights`);
};
export const getAmplifyMetasearchConnectorServiceApi = () => {
    return (system.amplifyMetasearchConnectorServiceApiBase ||
        `${getApiBaseUrl()}/amplify-metasearch-connector`);
};
export const getLaunchDarklyApiKey = () => {
    return (system.launchDarklyApiKey ||
        (getEnvironment() === 'prod'
            ? '6622cd9d6be9690f3ebae4e4'
            : '6622ce48f758a10f98ea6c92'));
};
// Script attributes collected from the current script tag (URL params, attributes, and dataset).
// All attribute names are converted to camelCase, and all values are strings.
// These should not change at runtime as they are captured during initial script load.
export const scriptAttributes = system.scriptAttributes || {};
// @TECHDEBT: do we need this? how should we resolve it in the Immersive Experience
// manually set webpack public path
if (!isLocalDevelopment) {
    if (typeof window !== 'undefined') {
        window['__webpack_public_path__'] = getAssetPath() + '/';
    }
}
